import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import JustListedCard from '../../shared/JustListedCard/just.listed.card.vue';
import JustSoldCard from '../../shared/JustSoldCard/just.sold.card.vue';
import OpenhouseCard from '../../shared/OpenhouseCard/openhouse.card.vue';
import { IRealEstateCompanyCard } from '../../models/daily.report';
import BrokerageReport from './BrokerageReport/brokerage.report.vue';
import BrokerageListings from './BrokerageListings/brokerage.listings.vue';
import { CommonConfig } from '../../configs/config.common';
import { BrokerageNameDeocder } from '../../utils/brokerage.name.decoder';
import { baseUrlEncoder } from '../../utils/baseUrl.encoder';
import { UserInfoDelegate } from '../../services/DataDelegate/UserInfoDelegate/user.info.delegate';
import SpinLoader from '../../shared/SpinLoader/spin.loader.vue';
import { WechatDelegate } from '../../services/DataDelegate/WechatDelegate/wechat.delegate';
import { Models } from '../../models/models';
import { AxiosPromise } from '../../utils/axios.promise';
import * as T_T from 'cryface';
import { HimuraInject } from 'himura';
import AgentFrontstoreStandardLayout from '../../layout/AgentFrontstoreStandardLayout/agent.frontstore.standard.layout.vue';

@Component({
   components: {
      JustListedCard,
      JustSoldCard,
      OpenhouseCard,
      BrokerageReport,
      BrokerageListings,
      SpinLoader,
      'layout': AgentFrontstoreStandardLayout,
   }
})
export default class DailyReportPage extends Vue {
   public title: string = 'DailyReportPage';

   public bannerFolder: string = '../../assets/BrokerageResources';

   public commonConfig = new CommonConfig();

   public tab = 'new';

   public userInfoService = new UserInfoDelegate();

   public wechat = new WechatDelegate();

   public isLoading = true;

   @Watch('$store.state.dailyReport.isFetching', { immediate: true, deep: true })
   public onLoading(val: any, oldVal: any) {
      this.isLoading = val;
   }

   public data: any = {
      justListed: [], // classfied by real estate brokerage name
      justSold: [],
      openhouse: []
   };

   public async created() {
      this.$store.commit('dailyReportStartFetching');
      await this.getDailyReport();
      await this.configuringWX();
      // await this.configSocial(); // no needed for report
      await T_T.delay(500);
      this.$store.commit('dailyReportEndFetching');
   }

   public async getDailyReport() {
      this.data.justListed = [];
      this.data.justSold = [];
      this.data.openhouse = [];
      await Promise.all([this.getOpenHouse(), this.getJustListed(), this.getJustSold()]);
   }

   public async getJustSold() {
      const host = this.commonConfig.cmisapiHost;
      const uri = `${host}/blogArticle/dailylistings?type=sold&ltype=0&count=${this.commonConfig.dailyReportNumber}`;
      const data: any = await AxiosPromise.get(uri);
      if (data.code === 200) {
         const fetched = data.data;
         this.classifier(fetched, 'justSold');
         return;
      }
      return;
   }

   public async getJustListed() {
      const host = this.commonConfig.cmisapiHost;
      const uri = `${host}/blogArticle/dailylistings?type=new&ltype=0&count=${this.commonConfig.dailyReportNumber}`;
      const data: any = await AxiosPromise.get(uri);
      if (data.code === 200) {
         const fetched = data.data;
         this.classifier(fetched, 'justListed');
         return;
      }
      return;
   }

   public async getOpenHouse() {
      const host = this.commonConfig.cmisapiHost;
      const uri = `${host}/blogArticle/dailylistings?type=openhouse&ltype=0&count=${this.commonConfig.dailyReportNumber}`;
      const data: any = await AxiosPromise.get(uri);
      if (data.code === 200) {
         const fetched = data.data;
         this.classifier(fetched, 'openhouse');
         return;
      }
      return;
   }

   public classifier(data: any[], type: string) {
      const cardEstate: IRealEstateCompanyCard = {
         id: 1,
         name: '',
         type: type,
         listings: [],
         isCapturing: false
      };
      const cardMasterTrust: IRealEstateCompanyCard = {
         id: 1,
         name: '',
         type: type,
         listings: [],
         isCapturing: false
      };
      const cardMasterChoice: IRealEstateCompanyCard = {
         id: 1,
         name: '',
         type: type,
         listings: [],
         isCapturing: false
      };
      const cardRoyalElite: IRealEstateCompanyCard = {
         id: 1,
         name: '',
         type: type,
         listings: [],
         isCapturing: false
      };
      const cardHomeArt: IRealEstateCompanyCard = {
         id: 1,
         name: '',
         type: type,
         listings: [],
         isCapturing: false
      };
      const cardRifo: IRealEstateCompanyCard = {
         id: 1,
         name: '',
         type: type,
         listings: [],
         isCapturing: false
      };
      const cardRifoGroup: IRealEstateCompanyCard = {
         id: 1,
         name: '',
         type: type,
         listings: [],
         isCapturing: false
      };
      // let countTest = 0;
      data.map((v: any) => {
         if (BrokerageNameDeocder.isEstate(v.brokerage)) {
            // if (countTest < 4) {
            //    cardEstate.name = v.brokerage;
            //    cardEstate.listings.push(v);
            //    console.log(countTest);
            //    countTest = countTest + 1;
            // }
            cardEstate.name = v.brokerage;
            cardEstate.listings.push(v);
         }
         if (BrokerageNameDeocder.isMasterChoice(v.brokerage)) {
            cardMasterChoice.name = v.brokerage;
            cardMasterChoice.listings.push(v);
         }
         if (BrokerageNameDeocder.isMasterTrust(v.brokerage)) {
            cardMasterTrust.name = v.brokerage;
            cardMasterTrust.listings.push(v);
         }
         if (BrokerageNameDeocder.isRifo(v.brokerage)) {
            cardRifo.name = v.brokerage;
            cardRifo.listings.push(v);
         }
         if (BrokerageNameDeocder.isRoyalElite(v.brokerage)) {
            cardRoyalElite.name = v.brokerage;
            cardRoyalElite.listings.push(v);
         }
         if (BrokerageNameDeocder.isHomeArt(v.brokerage)) {
            cardHomeArt.name = v.brokerage;
            cardHomeArt.listings.push(v);
         }
         cardRifoGroup.name = 'RIFO HOLDING GROUP';
         cardRifoGroup.listings.push(v);
         // if (BrokerageNameDeocder.isRifo(v.brokerage)) {
         // }
      });
      if (cardEstate.listings.length > 0) {
         this.data[type].push(cardEstate);
      }
      if (cardMasterTrust.listings.length > 0) {
         this.data[type].push(cardMasterTrust);
      }
      if (cardMasterChoice.listings.length > 0) {
         this.data[type].push(cardMasterChoice);
      }
      if (cardRifo.listings.length > 0) {
         this.data[type].push(cardRifo);
      }
      if (cardRoyalElite.listings.length > 0) {
         this.data[type].push(cardRoyalElite);
      }
      if (cardHomeArt.listings.length > 0) {
         this.data[type].push(cardHomeArt);
      }
      if (cardRifoGroup.listings.length > 0) {
         this.data[type].push(cardRifoGroup);
      }
   }

   public bannerMapper(type: string, name: string) {
      let file = '';
      if (type === 'justListed') {
         file = '/just-listed-header';
      }
      if (type === 'justSold') {
         file = '/just-sold-header';
      }
      if (type === 'openhouse') {
         file = '/openhouse-header';
      }
      let brokeragePath = '';
      if (BrokerageNameDeocder.isEstate(name)) {
         brokeragePath = '/Eastide';
      } else if (BrokerageNameDeocder.isMasterChoice(name)) {
         brokeragePath = '/MasterChoice';
      } else if (BrokerageNameDeocder.isMasterTrust(name)) {
         brokeragePath = '/MasterTrust';
      } else if (BrokerageNameDeocder.isRifo(name)) {
         brokeragePath = '/RIFO';
      } else if (BrokerageNameDeocder.isRoyalElite(name)) {
         brokeragePath = '/RoyalElite';
      } else if (BrokerageNameDeocder.isHomeArt(name)) {
         brokeragePath = '/HomeArt';
      } else if (BrokerageNameDeocder.isRifoGroup(name)) {
         brokeragePath = '/RIFOGroup';
      }
      return `BrokerageResources${brokeragePath}${file}`;
   }

   public footerMapper(name: string) {
      const file = '/daily-footer';
      let brokeragePath = '';
      if (BrokerageNameDeocder.isEstate(name)) {
         brokeragePath = '/Eastide';
      } else if (BrokerageNameDeocder.isMasterChoice(name)) {
         brokeragePath = '/MasterChoice';
      } else if (BrokerageNameDeocder.isMasterTrust(name)) {
         brokeragePath = '/MasterTrust';
      } else if (BrokerageNameDeocder.isRifo(name)) {
         brokeragePath = '/RIFO';
      } else if (BrokerageNameDeocder.isRoyalElite(name)) {
         brokeragePath = '/RoyalElite';
      } else if (BrokerageNameDeocder.isHomeArt(name)) {
         brokeragePath = '/HomeArt';
      } else if (BrokerageNameDeocder.isRifoGroup(name)) {
         brokeragePath = '/RIFOGroup';
      }
      return `BrokerageResources${brokeragePath}${file}`;
   }

   public async capture(id: string) {
      const type = id.slice(0, id.length - 1);
      const idNumber = id[id.length - 1];
      const promises: Promise<any>[] = [];
      this.data[type][idNumber].isCapturing = true;
      this.data[type][idNumber].listings.map((v: any) => {
         promises.push(
            new Promise(async (resolve, reject) => {
               v.image = await baseUrlEncoder(v.image);
               resolve(1);
            })
         );
      });
      await Promise.all(promises);
      this.$store.commit('print', id);
      await T_T.delay(5000);
      this.data[type][idNumber].isCapturing = false;
   }

   public isWechat() {
      return this.wechat.isWeChat();
   }

   public async configSocial() {
      const link = location.href.split('#')[0];
      const config = {
         url: link, // 网址，默认使用 window.location.href
         source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
         title: `Rifo DailyReport`, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
         description: `每日精彩房源, 就在RIFO。 Speed Listing Report Flyers`, // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
         image: 'https://files.realjaja.com/rifo_wechat_logo.png', // 图片, 默认取网页中第一个img标签
         wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
         wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可分享至朋友圈。</p>'
      };
      this.$store.commit('setSocialShare', config);
   }

   public async configuringWX() {
      if (this.wechat.isWeChat()) {
         const entry = HimuraInject.Injector.getInstance().getResourceByKey('entryUrl')!.value;
         const link = this.wechat.isWechatIos() ? entry.split('#')[0] : location.href.split('#')[0];
         const shareConfig: Models.IWechatShareConfig = {
            title: `Rifo DailyReport`,
            desc: `每日精彩房源, 就在RIFO。 Speed Listing Report Flyers`,
            link: location.href.split('#')[0],
            imgUrl: 'https://files.realjaja.com/rifo_wechat_logo.png',
            success: () => {
            }
         };
         const wx = require('weixin-js-sdk');
         const options = await this.wechat.getConfig(link);
         wx.config(options);
         try {
            await this.wechat.ReadyPromise(wx);
            this.wechat.share(wx, shareConfig);
         } catch (e) {
            alert(e.errMsg);
            alert(location.href);
         }
      }
   }
}
